import { GET_GOV_HOME_SERVICES } from '../../constants/ActionTypes';

const initialState = {
  servicosDestaque: [],
  servicosMaisAcessados: [],
  recomUrl: null,
  loading: false,
  error: null,
  loaded: false,
};

/**
 * Maps service items to the desired format.
 * @param {Array} items Array of service items.
 * @returns {Array} Mapped array of service items.
 */
function mapServiceItems(items) {
  if (!items || !items.length) {
    return [];
  }

  return items.map(
    ({ titulo_destaque, titulo, sigla, categoria, url, ...rest }) => ({
      ...rest,
      title: `${titulo_destaque || titulo}${sigla ? ` (${sigla})` : ''}`,
      category: categoria,
      path: url,
    }),
  );
}

/**
 * Search Settings reducer.
 * @function site
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function gov_home_services(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_GOV_HOME_SERVICES}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_GOV_HOME_SERVICES}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        servicosDestaque: mapServiceItems(action.result.servicos_destaque),
        servicosMaisAcessados: mapServiceItems(
          action.result.servicos_mais_acessados,
        ),
        recomUrl: action.result?.data_recom_uri,
      };
    case `${GET_GOV_HOME_SERVICES}_FAIL`:
      return {
        ...initialState,
        loaded: true,
        loading: false,
        error: action.payload,
        servicosDestaque: [],
        servicosMaisAcessados: [],
        recomUrl: null,
      };
    default:
      return state;
  }
}
